import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=1b4f4e44&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=ts&"
export * from "./Video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f4e44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/var/www/components/Video.vue').default})
